import { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS, SCREEN_WIDTHS } from '../../constants'
import MainModule from '../../modules/main'
import { Locale } from '../../modules/locale'
import { getVisibleWidth } from '../../modules/utils'

Locale.getInstance().registerKeySet('fr', 'profile', {
  title: 'Mon compte',
  notification: 'Notifications',
  personal: 'Mes infos personnelles',
  security: 'Connexion et sécurité',
  culture: 'Mon profil culturel',
  favorites: 'Mes favoris',
  createEvent: 'Soumettre un événement',
  createExhibition: 'Soumettre une exposition',
  partnerProfile: 'Profil partenaire',
  termsOfUse: 'Conditions d’utilisation',
  termsOfUseLink: '/fr/conditions-d-utilisation',
})

Locale.getInstance().registerKeySet('en', 'profile', {
  title: 'My account',
  notification: 'Notifications',
  personal: 'My personal information',
  security: 'Sign in and security',
  culture: 'My cultural profile',
  favorites: 'My favourites',
  createEvent: 'Submit an event',
  createExhibition: 'Submit an exhibition',
  partnerProfile: 'Partner profile',
  termsOfUse: 'Terms of use',
  termsOfUseLink: '/en/terms-and-conditions',
})

export interface LvcProfileModalWrapper {}

export class LvcProfileModalWrapper extends MinzeElement {
  modalId = MODALS.PROFILE_MODAL
  reactive: Reactive = [['isDesktop', true]]

  onReady(): void | Promise<void> {
    this.isDesktop = getVisibleWidth() > SCREEN_WIDTHS.DESKTOP_SMALL
    this.rerender()
  }

  html = () => `
  ${
    this.isDesktop
      ? `<lvc-modal is-fullscreen-modal-scrollable="true" modal-id="${this.modalId}" full-height="false" show-when-logged="true">
          <div slot="lvc-modal-content">
            <lvc-profile-desktop-screen-content></lvc-profile-desktop-screen-content>
          </div>
        </lvc-modal>`
      : `
        <lvc-modal
          is-fullscreen-modal-scrollable="true"
          modal-id="${this.modalId}"
          show-when-logged="true"
          narrow="true"
          modal-title="${Locale.getKey('profile.title')}"
          title-size="36px"
          mobile-title-centered="true"
        >
          <div slot="lvc-modal-content">
            <lvc-profile-modal-content></lvc-profile-modal-content>
          </div>
        </lvc-modal>
      `
  }
  `

  css = () => `
    :host {

    }
  `
}
